"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ESituacaoMatriculaAbreviado = exports.ESituacaoMatricula = void 0;
var ESituacaoMatricula;
(function (ESituacaoMatricula) {
    ESituacaoMatricula["Falecido"] = "0";
    ESituacaoMatricula["Estudando"] = "1";
    ESituacaoMatricula["Desistente"] = "2";
    ESituacaoMatricula["Transferido"] = "3";
    ESituacaoMatricula["Remanejado"] = "4";
    ESituacaoMatricula["TranferidoCurso"] = "5";
    ESituacaoMatricula["Aprovado"] = "+";
    ESituacaoMatricula["Reprovado"] = "-";
    ESituacaoMatricula["ExameRecupera\u00E7\u00E3o"] = "*";
    ESituacaoMatricula["Trancado"] = "!";
    ESituacaoMatricula["Cancelado"] = "#";
})(ESituacaoMatricula = exports.ESituacaoMatricula || (exports.ESituacaoMatricula = {}));
var ESituacaoMatriculaAbreviado;
(function (ESituacaoMatriculaAbreviado) {
    ESituacaoMatriculaAbreviado["E.C"] = "1";
    ESituacaoMatriculaAbreviado["DES"] = "2";
    ESituacaoMatriculaAbreviado["AP"] = "+";
    ESituacaoMatriculaAbreviado["REP"] = "-";
    ESituacaoMatriculaAbreviado["FAL"] = "0";
    ESituacaoMatriculaAbreviado["TRA"] = "3";
    ESituacaoMatriculaAbreviado["REM"] = "4";
    ESituacaoMatriculaAbreviado["T.C"] = "5";
    ESituacaoMatriculaAbreviado["E.R"] = "*";
    ESituacaoMatriculaAbreviado["TR"] = "!";
    ESituacaoMatriculaAbreviado["CAN"] = "#";
})(ESituacaoMatriculaAbreviado = exports.ESituacaoMatriculaAbreviado || (exports.ESituacaoMatriculaAbreviado = {}));
